var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',_vm._l((_vm.headers),function(header){return _c('td',{key:header.value,class:_vm.getHeaderClasses(header),style:(_vm.getCellStyles(header))},[_vm._t(`item.${header.value}`,function(){return [_vm._v(" "+_vm._s(_vm.item[header.value])+" ")]},{"item":_vm.item,"value":_vm.item[header.value]})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }